import './App.css';
import Wizard from './components/Wizard';

function App() {
  return (
    <div className="App">
      <Wizard />
    </div>
  );
}

export default App;
